export const getTextWidth = (text: string, element?: HTMLElement | null) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      if (element) {
        const computedStyle = window.getComputedStyle(element);
        // Tam font özelliklerini al
        const fontSize = computedStyle.fontSize;
        const fontWeight = computedStyle.fontWeight;
        const fontFamily = computedStyle.fontFamily;
        const letterSpacing = computedStyle.letterSpacing;
        
        context.font = `${fontWeight} ${fontSize} ${fontFamily}`;
        
        // Letter spacing ve padding ekleyerek daha doğru ölçüm
        const textWidth = context.measureText(text).width;
        const letterSpacingValue = letterSpacing !== 'normal' ? parseFloat(letterSpacing) : 0;
        const totalLetterSpacing = letterSpacingValue * (text.length - 1);
        
        // Ekstra padding ekle
        const returnValue = textWidth + totalLetterSpacing + 3; // 10px ekstra padding
        return returnValue > 140 ? 140 : returnValue;
      } else {
        // Varsayılan font stillerini kullan
        context.font = '500 14px Mont Regular';
        const returnValue = context.measureText(text).width + 3; // Varsayılan durumda da padding ekle
        return returnValue > 140 ? 140 : returnValue;
      }
    }
    return 0;
  };


  export const capitalizeWords = (str: string) => {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };